const menuButton = document.querySelector('.navbar-toggler');
const mobileMenu = document.getElementById('navbarNavDropdown');
const mainNav = document.getElementById('main-nav');
const mobileNavOverlay = document.querySelector('.mobile-nav-overlay');
const mobileMenuBreakpoint = window.matchMedia('(max-width: 991px)');

if (menuButton && mobileMenu && mainNav) {
    const closeMobileMenu = () => {
        mobileMenu.classList.remove('is-open');
        mainNav.classList.remove('is-menu-open');
        document.body.classList.remove('mobile-nav-open');
        menuButton.classList.remove('is-active');
        menuButton.setAttribute('aria-expanded', 'false');
    };

    const openMobileMenu = () => {
        mobileMenu.classList.add('is-open');
        mainNav.classList.add('is-menu-open');
        document.body.classList.add('mobile-nav-open');
        menuButton.classList.add('is-active');
        menuButton.setAttribute('aria-expanded', 'true');
    };

    const toggleMobileMenu = () => {
        if (mobileMenu.classList.contains('is-open')) {
            closeMobileMenu();
            return;
        }

        openMobileMenu();
    };

    menuButton.addEventListener('click', toggleMobileMenu);

    if (mobileNavOverlay) {
        mobileNavOverlay.addEventListener('click', closeMobileMenu);
    }

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
            closeMobileMenu();
        }
    });

    document.querySelectorAll('#main-menu a').forEach((link) => {
        link.addEventListener('click', () => {
            if (mobileMenuBreakpoint.matches) {
                closeMobileMenu();
            }
        });
    });

    window.addEventListener('resize', () => {
        if (!mobileMenuBreakpoint.matches) {
            closeMobileMenu();
        }
    });
}

const toBeAnimated = document.querySelectorAll('.animate');

toBeAnimated.forEach(element => {
    element.classList.add('hide');
});

const fadeOptions = {
    threshold: .3,
};

const appearOnScroll = new IntersectionObserver((entries, appearOnScroll) => {
    entries.forEach(entry => {
        if (!entry.isIntersecting) {
            return;
        } else {
                entry.target.classList.remove('hide');
                entry.target.classList.add('show');
                appearOnScroll.unobserve(entry.target);
        }
    })
}, fadeOptions);

toBeAnimated.forEach(element => {
    appearOnScroll.observe(element);
});

/*
 * Smooth scrolling functionality is intentionally disabled.
 * If needed in the future, restore the block below and adapt as necessary.
 */
// const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
//
// const smoothScrollToTarget = (target) => {
//     const nav = document.getElementById('main-nav');
//     const offset = nav ? nav.offsetHeight : 0;
//     const top = target.getBoundingClientRect().top + window.scrollY - offset;
//
//     window.scrollTo({
//         top,
//         behavior: 'smooth',
//     });
// };
//
// const smoothScrollToHash = (hash) => {
//     if (!hash || hash.length <= 1) {
//         return;
//     }
//
//     const target = document.querySelector(hash);
//     if (!target) {
//         return;
//     }
//
//     smoothScrollToTarget(target);
// };
//
// if (!prefersReducedMotion) {
//     document.querySelectorAll('a[href^="#"]').forEach(anchor => {
//         anchor.addEventListener('click', (event) => {
//             const hash = anchor.getAttribute('href');
//
//             if (!hash || hash.length <= 1) {
//                 return;
//             }
//
//             const target = document.querySelector(hash);
//             if (!target) {
//                 return;
//             }
//
//             event.preventDefault();
//             history.pushState(null, '', hash);
//             smoothScrollToTarget(target);
//         });
//     });
//
//     if (window.location.hash) {
//         window.addEventListener('load', () => smoothScrollToHash(window.location.hash));
//     }
// }
